<h1 mat-dialog-title>Update Required</h1>
<div mat-dialog-content>
	<p>Please install the latest mobile version.</p>
</div>
<div mat-dialog-actions>
	<button mat-button (click)="onAllowClick()" cdkFocusInitial>Update</button>
</div>
